import { useEffect, useRef, useCallback } from 'react';

const useOutsideClickDetector = <T extends HTMLElement = HTMLElement>(
  cb: () => void,
  open: boolean,
  excludeRef?: React.RefObject<HTMLElement>[],
): React.RefObject<T> => {
  const containerRef = useRef<T>(null);

  const detectClick = useCallback(
    (e: MouseEvent) => {
      if (open && containerRef.current && !containerRef.current.contains(e.target as Node)) {
        if (excludeRef?.some((ref) => ref.current?.contains(e.target as Node))) {
          return;
        }
        cb();
      }
    },
    [open, cb, excludeRef],
  );

  useEffect(() => {
    window.addEventListener('click', detectClick);
    return () => {
      window.removeEventListener('click', detectClick);
    };
  }, [detectClick]);

  return containerRef as React.RefObject<T>;
};

export default useOutsideClickDetector;
